<template>
  <ConfirmDialog
      v-model="dialog"
      @update:agree="save"
      @update:cancel="cancel"
      ref="confirm"
  >
    <template v-slot:title>{{ $t('Наименование сервиса') }}</template>
    <template v-slot:content>
      <v-card-text class="pa-4 text-black">
        <v-form v-model="valid" ref="form">
          <Input
              v-model="values.name"
              label="Введите наименование сервиса"
              :rules="[].concat(validation.required(false, 'Укажите наименование сервиса для интеграции'))"
              :maxlength="255"
              required
          />
          <template v-for="(field, index) in additionalFields" :key="index">
            <component
                v-model:values="values"
                :is="field"
                :type="type"
            />
          </template>
        </v-form>
      </v-card-text>
    </template>
    <template v-slot:cancelText>{{ $t('Отменить') }}</template>
    <template v-slot:agreeText>{{ $t('Сохранить') }}</template>
  </ConfirmDialog>
</template>

<script>
import Input from "@intec/vue-components/form/Input.vue";
import { useApiIntegrationComponentStore } from '@/stores/apiIntegrationComponentStore.js';
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";
import validation from "@/components/validation";

export default {
  name: 'SaveFormDlg',
  components: { ConfirmDialog, Input },
  data() {
    const { getFields } = useApiIntegrationComponentStore();
    const additionalFields = getFields();

    return {
      additionalFields,
      dialog: false,
      resolve: null,
      reject: null,
      valid: true,
      type: '',
      values: {
        name: '',
      },
      options: {
        width: 600,
        zIndex: 200,
        noconfirm: false,
        placeholder: '',
        saveText: 'Сохранить',
        cancelText: 'Отменить',
      },
      validation
    };
  },
  computed: {
    isEmptyName() {
      return !this.values.name?.length;
    },
  },
  methods: {
    open(type, item) {
      this.dialog = true;
      this.type = type;
      this.values.name = item?.name ?? '';

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    async save() {
      if (!(await this.$refs.form.validate()).valid) {
        return;
      }

      this.dialog = false;
      this.resolve({
        confirmed: true,
        value: this.values,
      });
      this.values = {
        name: '',
      };
    },
    cancel() {
      this.dialog = false;
      this.values = {
        name: '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-input *) {
  font-family: 'Manrope';
  font-weight: 400 !important;
}

:deep(.v-field-label) {
  font-size: 16px !important;
  line-height: 24px;
  letter-spacing: 0.15px;
}

:deep(.v-field-label--floating) {
  font-size: 12px !important;
  line-height: 18px;
  letter-spacing: 0.11px;
}

:deep(.v-field__input) {
  font-size: 16px !important;
  line-height: 22px;
  letter-spacing: 0.15px;
}
</style>
